import React, { useState } from 'react';
import Card from './ui/Card';
import Button from './ui/Button';

interface ErrorReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  t: {
    title: string;
    name: string;
    email: string;
    description: string;
    submit: string;
    subject: string;
  };
}

const ErrorReportModal = ({ isOpen, onClose, t }: ErrorReportModalProps) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    description: '',
  });

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const body = `Nombre: ${formData.name}\nEmail: ${formData.email}\n\nDescripción del error:\n${formData.description}`;
    const mailtoUrl = `mailto:errores-web@negolan.com?subject=${encodeURIComponent(t.subject)}&body=${encodeURIComponent(body)}`;
    
    window.location.href = mailtoUrl;
    onClose();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
      <Card className="w-full max-w-lg bg-slate-800 border-slate-700 shadow-2xl animate-fade-in">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold text-white">{t.title}</h2>
            <button 
              onClick={onClose}
              className="text-slate-400 hover:text-white transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">{t.name}</label>
              <input
                required
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-2.5 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">{t.email}</label>
              <input
                required
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-2.5 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">{t.description}</label>
              <textarea
                required
                name="description"
                maxLength={2000}
                rows={5}
                value={formData.description}
                onChange={handleChange}
                className="w-full bg-slate-900 border border-slate-700 rounded-lg p-2.5 text-white focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
              ></textarea>
              <div className="text-right text-xs text-slate-500 mt-1">
                {formData.description.length} / 2000
              </div>
            </div>

            <div className="pt-2">
              <Button type="submit" variant="secondary" className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                {t.submit}
              </Button>
            </div>
          </form>
        </div>
      </Card>
      
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in { animation: fade-in 0.2s ease-out forwards; }
      `}</style>
    </div>
  );
};

export default ErrorReportModal;
